// extracted by mini-css-extract-plugin
export default {"benefits":"responsiveStyles_benefits__uqyjt","fourBenefits":"responsiveStyles_fourBenefits__K7nPo","carWithCta":"responsiveStyles_carWithCta__fvdUB"};